import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as GensetIcon } from "../../assets/diesel_generator.svg";

const GensetBar = ({
  x,
  y,
  width,
  height,
  iconX,
  iconY,
  value,
  fill,
  fillOpacity,
  iconGroupScale = 1,
  iconGroupTransition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  onMouseEnter,
  onMouseMove,
  onMouseLeave,
}) => {
  return (
    <g id="genset-top-group" transform="translate(0,0)">
      <g
        id="right-top-genset-bar-genset-icon-above"
        transform={`translate(${iconX} ${iconY}) scale(${iconGroupScale})`}
        style={{
          transition: iconGroupTransition,
          transformOrigin: '26px 26px',
        }}
      >
        <circle cx={26} cy={26} r={24} fill={fill} stroke={fill} strokeWidth={2} />
        <g transform="translate(10,10)">
          <GensetIcon width={32} height={32} fill="white" />
        </g>
        <text
          x={26}
          y={68}
          textAnchor="middle"
          fill={fill}
          fontSize="12"
          fontWeight="700"
        >
          {value}
        </text>
      </g>
      <rect
        id="right-top-genset-bar"
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        fillOpacity={fillOpacity}
        style={{ cursor: "pointer" }}
        onMouseEnter={onMouseEnter}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
      />
    </g>
  );
};

GensetBar.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  iconX: PropTypes.number.isRequired,
  iconY: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string.isRequired,
  fillOpacity: PropTypes.number,
  iconGroupScale: PropTypes.number,
  iconGroupTransition: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default GensetBar;
